/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SiaAuthGuard implements CanActivate {
  private router = inject(Router);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  canActivate(): // route: ActivatedRouteSnapshot,
  // state: RouterStateSnapshot
  Observable<boolean> | Promise<boolean> | boolean {
    // return this.authService.isAuthenticated().pipe(
    //   tap(authenticated => {
    //         //     if (!authenticated) {
    //       this.router.navigate(["auth/login"]);
    //     }
    //   })
    // );
    return true;
  }
}
